/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientTermsAndConditionsTarget } from './';
import {
    ClientTermsAndConditionsTargetFromJSON,
    ClientTermsAndConditionsTargetFromJSONTyped,
    ClientTermsAndConditionsTargetToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientTermsAndConditionsResource
 */
export interface ClientTermsAndConditionsResource {
    /**
     * 
     * @type {string}
     * @memberof ClientTermsAndConditionsResource
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientTermsAndConditionsResource
     */
    fileUrl: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientTermsAndConditionsResource
     */
    validityStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClientTermsAndConditionsResource
     */
    validityEndDate?: Date;
    /**
     * 
     * @type {ClientTermsAndConditionsTarget}
     * @memberof ClientTermsAndConditionsResource
     */
    target?: ClientTermsAndConditionsTarget;
}

/**
 * Check if a given object implements the ClientTermsAndConditionsResource interface.
 */
export function instanceOfClientTermsAndConditionsResource(value: object): value is ClientTermsAndConditionsResource {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('fileUrl' in value) || value['fileUrl'] === undefined) return false;
    return true;
}

export function ClientTermsAndConditionsResourceFromJSON(json: any): ClientTermsAndConditionsResource {
    return ClientTermsAndConditionsResourceFromJSONTyped(json, false);
}

export function ClientTermsAndConditionsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTermsAndConditionsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'fileUrl': json['fileUrl'],
        'validityStartDate': json['validityStartDate'] == null ? undefined : (new Date(json['validityStartDate'])),
        'validityEndDate': json['validityEndDate'] == null ? undefined : (new Date(json['validityEndDate'])),
        'target': json['target'] == null ? undefined : ClientTermsAndConditionsTargetFromJSON(json['target']),
    };
}

export function ClientTermsAndConditionsResourceToJSON(value?: ClientTermsAndConditionsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileName': value['fileName'],
        'fileUrl': value['fileUrl'],
        'validityStartDate': value['validityStartDate'] == null ? undefined : ((value['validityStartDate']).toISOString()),
        'validityEndDate': value['validityEndDate'] == null ? undefined : ((value['validityEndDate']).toISOString()),
        'target': ClientTermsAndConditionsTargetToJSON(value['target']),
    };
}

